import React from 'react';
import {Header, Breadcrumb, Icon, Label, Item,Segment,Container, Loader, Dropdown, Divider, Form, Dimmer, TextArea, Image, Table,  Button, Grid,Input, Radio, Message,MessageItem, MessageList, MessageHeader ,CardContent, Card} from 'semantic-ui-react';
import { Link } from "react-router-dom";
import Content from '../NetflixSlider/ContentHeader';
import {moneda, stringToDate} from '../../util/index';


import { PayPalScriptProvider } from "@paypal/react-paypal-js";
import PaypalCheckoutButton from "../common/PaypalCheckoutButton";

/* 

  
        <Segment basic>
        
        
    
         
              

           
           <Grid stackable>
                <Grid.Row >
                    <Grid.Column >    
                        <Header as='h2' dividing>
                            {pagosLista.length>0?    
                                <p>{strings?strings["Pagos"]:""}</p>
                             :
                                <p>{strings?strings["SinPagosPendientes"]:""}</p>
                            }
                        </Header>
                    </Grid.Column>
                </Grid.Row>        
                 <Grid.Row >
                    <Grid.Column >         
                     {pagosLista.length>0?
    
                     <Table>
                            <Table.Header>
                                <Table.Row>
                                <Table.HeaderCell>{strings?strings["FormaPago"]:""}</Table.HeaderCell>
                                <Table.HeaderCell>{strings?strings["Curso"]:""}</Table.HeaderCell>
                                <Table.HeaderCell textAlign="right">{strings?strings["FechaLimite"]:""}</Table.HeaderCell>
                                <Table.HeaderCell textAlign="right">{strings?strings["Monto"]:""}</Table.HeaderCell>
                                <Table.HeaderCell textAlign="center">{strings?strings["Seleccionar"]:""}</Table.HeaderCell>
                                </Table.Row>
                            </Table.Header>



                            <Table.Body>

                              {pagosLista.map(pago =>


                                <Table.Row>
              
                                <Table.Cell >PayPal</Table.Cell>    
                                <Table.Cell >{pago.curso}</Table.Cell>
                               
                                <Table.Cell textAlign="right">{stringToDate(pago.fechaPago2)}</Table.Cell>


                                <Table.Cell textAlign="right">{moneda(pago.montoPago)}</Table.Cell>
                                
                                <Table.Cell textAlign="center">
                                    {pago.pagado==0?
                                        <Radio
                                            label="Seleccióna pago"
                                            name='radioGroup'
                                            value={pago.id}
                                            checked={pagoLiquidar.id === pago.id}
                                            onChange={()=>handleChangePago(pago.id)}
                                          />
                                     
                                    :
                                        <>{strings?strings["Pagado"]:""}</>
                                    }
                                </Table.Cell>
                                </Table.Row>

                            )}

                            
                            
                            {pagosLista.map(pago =>


                                <Table.Row>
                                    <Table.Cell>Depósito<br/> 
                                
                                    </Table.Cell>    
                               <Table.Cell >{pago.curso}</Table.Cell>
                               
                                <Table.Cell textAlign="right">{stringToDate(pago.fechaPago2)}</Table.Cell>


                                <Table.Cell textAlign="right">{moneda(pago.montoPago)}</Table.Cell>
                                
                                <Table.Cell textAlign="center">
                                    <Button color="blue" onClick={()=>onShowDeposito()}>Depósito</Button>
                                </Table.Cell>
                                </Table.Row>

                            )}

                            {showDeposito>0?
                                <Table.Row >
                                    <Table.Cell colSpan="5">
                                
                                
                                        <Message size='large' color='blue'>
                                           
                                           
                                            <MessageHeader>Datos de depósito</MessageHeader>
                                                <br/>
                                                <p><b>Si el pago lo quieres realizar por transferencia bancaria tu pago en la siguiente cuenta:</b></p>
                                                <MessageList>
                                                  <MessageItem>QUIALIS INTERNATIONAL LLC</MessageItem>
                                                  <MessageItem>BANCO: BANK OF AMERICA</MessageItem>
                                                  <MessageItem>CUENTA: 8 9 8 1 1 8 8 3 9 1 9 7</MessageItem>
                                                  <MessageItem>(ROUTING): 0 6 3 0 0 0 0 4 7</MessageItem>
                                                  <MessageItem>ABA: 0 2 6 0 0 9 5 9 3</MessageItem>
                                                  <MessageItem>SWIFT: BOFAUS3N</MessageItem>
                                                  <MessageItem>CIUDAD: DORAL, FLORIDA, USA</MessageItem>
                                                  <MessageItem>SUCURSAL: DORAL PLAZA BANKING CENTER</MessageItem>
                                                </MessageList>
                                                
                                                <p>Esta transaccion será verificada en un plazo de 72 horas  </p>
                                            
                                          </Message>
                                        
                                        <Message size='large' color='blue'>
                                           
                                           
                                            <MessageHeader>¿Necesitas factura?</MessageHeader>
                                            <br/>
                                                <MessageList>
                                                  <p><b>Solicitala al siguiente correo atencion_academica@qsc.com.mx y envia los siguientes datos</b></p>
                                                  <MessageItem>Nombre o razón social</MessageItem>
                                                  <MessageItem>Identificación (despliega opciones Cedula, INE; NIT, RUT; RFC, ETC)</MessageItem>
                                                  <MessageItem>Dirección</MessageItem>
                                                  <MessageItem>Código postal</MessageItem>
                                                  <MessageItem>Ciudad o municipio</MessageItem>
                                                  <MessageItem>País</MessageItem>
                                                  <MessageItem>Correo</MessageItem>
                                                    <p> Si el pago lo realiza una entidad, anexar copia del  RUT/ CONSTANCIA DE SITUACIÓN FISCAL  (enviar el archivo jpg o un pdf)<br/> La factura la recibirás en tu correo en 5 días hábiles, luego de verificar tu pago.</p>
                                                </MessageList>
                                           
                                            
                                          </Message>
                                                
                            
                                    </Table.Cell>    
                             
                                </Table.Row>
                            :""}

                            </Table.Body>



                        </Table>

                    :

                            ""
                            
            }    
                </Grid.Column>
            </Grid.Row>
            {pagosLista.length>0?    
            <Grid.Row >
                <Grid.Column textAlign="center">    
                {cursoPago.descripcion!=null?
                <PayPalScriptProvider options={{"client-id":process.env.REACT_APP_PAYPAL_CLIENT_ID,"currency":"USD", "locale":"es_MX"}}>
                    <div className="paypal-button-container">
                         <PaypalCheckoutButton curso={cursoPago} handleApprove={handleApprove} />
                    </div>
                </PayPalScriptProvider>
                :
                    <>{strings?strings["SeleccionaPago"]:""}</>
                }    
                </Grid.Column>
            </Grid.Row>                 
                        
            :
                ""
            }
            
          

        </Grid>     
           

         <Dimmer active={ajaxCallInProgress>0?true:false} inverted>
          		<Loader size='big'  content={strings?strings["Procesando"]:""}/>
          </Dimmer>
          
          
               
            <>         
            
               
            {pagosLista.length>0?    
                  <> 
                {cursoPago.descripcion!=null?
                <Segment> 
                <PayPalScriptProvider options={{"client-id":process.env.REACT_APP_PAYPAL_CLIENT_ID,"currency":"USD", "locale":"es_MX"}}>
                    <div className="paypal-button-container">
                         <PaypalCheckoutButton curso={cursoPago} handleApprove={handleApprove} />
                    </div>
                </PayPalScriptProvider>
                </Segment>
                :
                   ""
                }   
                </>


            :
                ""
            }

        
            </>                       
                                
        
        
        </Segment>
*/

const Miespacio=({ id, color, userInfo, pagos=[], showModalMetodosPago, cursosActuales,cursosPrevios,  form, onSave,onChange, ajaxCallInProgress, datos, errors={}, strings, permisos, constancias, pagosLista, handleApprove, pagoLiquidar, handleChangePago, cursoPago,showDeposito,onShowDeposito,onChangeDeposito})=>{
    
    
	return (
        <Container >
        <Dimmer.Dimmable   dimmed={ajaxCallInProgress>0?true:false}>
        
            {pagosLista.length>0?
              <>
                {pagosLista.map(pago =>
                    <Segment>
                            {pagosLista.length>0?    
                                <div>
                                    <Header as='h2' dividing>
                                        <p>{strings?strings["finalizarCompra"]:""}</p>
                                    </Header>
        
        
                                    <h3>Para concluir su inscripción, por favor seleccione su forma de pago; si selecciona Paypal su inscripción será automática, si selecciona deposito bancario por transferencia su inscripción quedará en un máximo de 72 horas<br/><br/></h3>

                                    <Segment attached>
                                            <Icon name='student' />Curso : {pago.curso}
                                    </Segment> 
        
                                    <Segment attached>
                                             <Icon name='dollar sign' />Monto a pagar : {pago.montoPago}
                                    </Segment>     
        
        
                                    <Header as='h2' dividing>
                                        <p>{strings?strings["formaPago"]:""}</p>
                                    </Header>
                                    <Segment>
                                        {pago.pagado==0?
                                            <div>    
                                            <Radio
                                                label="PayPal"
                                                name='radioGroup'
                                                value={pago.id}
                                                checked={pagoLiquidar.id === pago.id}
                                                onChange={()=>handleChangePago(pago.id)}
                                              />
                                              &nbsp;&nbsp;

                                                <>
                                                {pago.deposito==1?

                                                <Radio
                                                label="Depósito"
                                                name='deposito'
                                                value={showDeposito}
                                                checked={showDeposito===pago.id}
                                                onChange={()=>onChangeDeposito(pago.id)}
                                                />  
                                                
                                                :""
                                                }
                                                </>
                                                
                                                {pagosLista.length>0?    
                                                <> 
                                                    {cursoPago.descripcion!=null && cursoPago.reference_id===pago.id?
                                                       <Segment basic>
                                                        <PayPalScriptProvider options={{"client-id":process.env.REACT_APP_PAYPAL_CLIENT_ID,"currency":"USD", "locale":"es_MX"}}>
                                                            <div className="paypal-button-container">
                                                                 <PaypalCheckoutButton curso={cursoPago} handleApprove={handleApprove} />
                                                            </div>
                                                        </PayPalScriptProvider>
                                                        </Segment>
                                                        :
                                                           ""
                                                     }

                                                </>

                                                    
                                                :
                                                    ""
                                                }
                                                
                                                
                                              {showDeposito>0 && showDeposito===pago.id?

                                                        <Segment basic>
                                                            <Message size='large' color='blue'>
                                                                <MessageHeader>Datos de depósito</MessageHeader>
                                                                <br/>
                                                                <p><b>Si el pago lo quieres realizar por transferencia bancaria tu pago en la siguiente cuenta:</b></p>
                                                                <MessageList>
                                                                  <MessageItem>QUIALIS INTERNATIONAL LLC</MessageItem>
                                                                  <MessageItem>BANCO: BANK OF AMERICA</MessageItem>
                                                                  <MessageItem>CUENTA: 8 9 8 1 1 8 8 3 9 1 9 7</MessageItem>
                                                                  <MessageItem>(ROUTING): 0 6 3 0 0 0 0 4 7</MessageItem>
                                                                  <MessageItem>ABA: 0 2 6 0 0 9 5 9 3</MessageItem>
                                                                  <MessageItem>SWIFT: BOFAUS3N</MessageItem>
                                                                  <MessageItem>CIUDAD: DORAL, FLORIDA, USA</MessageItem>
                                                                  <MessageItem>SUCURSAL: DORAL PLAZA BANKING CENTER</MessageItem>
                                                                </MessageList>
                                                                <p>Esta transaccion será verificada en un plazo de 72 horas  </p>
                                                            </Message>

                                                            <Message size='large' color='blue'>
                                                                <MessageHeader>¿Necesitas factura?</MessageHeader>
                                                                <br/>
                                                                <MessageList>
                                                                  <p><b>Solicitala al siguiente correo atencion_academica@qsc.com.mx y envia los siguientes datos</b></p>
                                                                  <MessageItem>Nombre o razón social</MessageItem>
                                                                  <MessageItem>Identificación (despliega opciones Cedula, INE; NIT, RUT; RFC, ETC)</MessageItem>
                                                                  <MessageItem>Dirección</MessageItem>
                                                                  <MessageItem>Código postal</MessageItem>
                                                                  <MessageItem>Ciudad o municipio</MessageItem>
                                                                  <MessageItem>País</MessageItem>
                                                                  <MessageItem>Correo</MessageItem>
                                                                    <p> Si el pago lo realiza una entidad, anexar copia del  RUT/ CONSTANCIA DE SITUACIÓN FISCAL  (enviar el archivo jpg o un pdf)<br/> La factura la recibirás en tu correo en 5 días hábiles, luego de verificar tu pago.</p>
                                                                </MessageList>
                                                            </Message>
                                                        </Segment>


                                                        :""}    
                                                
                                                
                                                
                                              
                                              </div>

                                        :
                                            <>{strings?strings["Pagado"]:""}</>
                                        }
                                    
                                    </Segment>
                                
                                
                                
                               
                            
                            </div>
                             :
                                <p>{strings?strings["SinPagosPendientes"]:""}</p>
                            }
                            
                    </Segment>
        
                )}
                </>
            :
        
                ""
        
            }
        
        
        
      
        </Dimmer.Dimmable>
        
        
            
       
       
        
        </Container>
	);
};



export default Miespacio;